module.exports = __webpack_public_path__ + "img/image.9ac930a0.svg";